export interface AppConfig {
  apiMode: 'mock' | 'real';
  apiBaseUrl: string;
  enableDebugLogs: boolean;
}

const getConfig = (): AppConfig => {
  // Check environment variables first, fallback to defaults
  const apiMode = (import.meta.env.VITE_API_MODE as 'mock' | 'real') || 'mock';
  const apiBaseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';
  const enableDebugLogs = import.meta.env.VITE_ENABLE_DEBUG_LOGS === 'true' || false;

  return {
    apiMode,
    apiBaseUrl,
    enableDebugLogs,
  };
};

export const appConfig = getConfig();

// Helper function to check if we're in mock mode
export const isMockMode = () => appConfig.apiMode === 'mock';
export const isRealApiMode = () => appConfig.apiMode === 'real';
